import { useSelector, } from 'react-redux';
import { IReducerStore, } from '@Store';

const useAuth = () => {
  return useSelector((store: IReducerStore) => store.auth);
};

export { useAuth, };
